<template>
  <main>
    <client-only>
      <SectionHero :variant="hero.variant">
        <OrganismHero :hero="hero" />
        <template #footerShort>
          <div class="flex flex-col flex-1 gap-y-3 md:flex-row gap-x-[10px] justify-between">
            <div class="flex flex-col flex-1 gap-y-3 md:flex-row gap-x-[10px] md:items-end -md:order-2">
              <div>
                <AtomButtonDropdown :initial-index="initialCity" :items="getСityList" @select="onCitySelect" />
              </div>
              <div>
                <AtomButtonDropdown :items="getClubs" :initial-index="initialClub" @select="onClubSelect" />
              </div>
            </div>
            <AtomButton class="self-end -md:order-1 -md:w-full" :to="`/timetable/${$route.params.id}/kids`"
              >РАСПИСАНИЕ</AtomButton
            >
          </div>
        </template>
      </SectionHero>
    </client-only>
    <SectionDefault>
      <Builder :blocks="blocks" />
    </SectionDefault>
  </main>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AtomButton from '@/components/atoms/AtomButton'
import AtomButtonDropdown from '@/components/atoms/AtomButtonDropdown'
import OrganismHero from '@/components/organisms/layouts/OrganismHero'
import SectionDefault from '@/components/templates/layouts/SectionDefault'
import SectionHero from '@/components/templates/layouts/SectionHero'
import Builder from '@/components/builder/Builder'
import pageBuilder from '@/components/mixins/pageBuilder.js'

const mixinPageBuilder = pageBuilder({
  pageUrl: ({ route }) => route.params.page,
})

export default {
  name: 'FitnessKids',
  components: {
    Builder,
    AtomButton,
    SectionDefault,
    SectionHero,
    OrganismHero,
    AtomButtonDropdown,
  },
  mixins: [mixinPageBuilder],
  meta: {
    theme: 'dark',
  },
  asyncData({ error, route }) {
    if (route.params.page === 'kids-yasenevo') {
      return error({ statusCode: 404, message: 'Страница не найдена' })
    }
  },
  data: c => {
    return {
      hero: {
        variant: 'dark-parallax',
        title1: 'Детский',
        title2: 'клуб',
        image: 'fitness/kids-clubs/hero.webp',
        imageWrap: 'img-border-0',
        imageMobile: 'fitness/kids-clubs/hero-mobile.webp',
        breadcrumbs: c.$breadcrumbs.kidsClubs(),
      },
    }
  },
  computed: {
    ...mapGetters({
      getClubs: 'modules/groupTrainings/getClubs',
      getСityList: 'modules/groupTrainings/getСityList',
    }),
    club() {
      return this.$store.getters['modules/content/clubs'].find(c => c.slug === this.$route.params.id) || { title: '' }
    },
    initialCity() {
      return this.getСityList?.findIndex(({ slug }) => slug == this.$route.params.city)
    },
    initialClub() {
      const index = this.getClubs?.findIndex(({ slug }) => slug == this.$route.params.id)
      return index >= 0 ? index : 0
    },
  },

  async created() {
    try {
      await this.fetchCity('kids')
      await this.setInitialClub()
    } catch (err) {
      console.error(err)
    }
  },

  destroyed() {
    this.$store.dispatch('pageTransition/skip')
    // this.$store.dispatch('pageTransition/toDefault')
  },

  methods: {
    ...mapActions({
      fetchCity: 'modules/groupTrainings/fetchCity',
      fetchClubs: 'modules/groupTrainings/fetchClubs',
    }),

    getKidsClubPage(slug) {
      const kidsClubMap = {
        // encore_yasenevo: 'kids-yasenevo',
        encore_khodynka: 'kids-khodynka',
      }

      const kidsClubPage = kidsClubMap[slug]

      if (!kidsClubPage) {
        return this.$nuxt.error({ statusCode: 404, message: 'Страница не найдена' })
      }

      return kidsClubPage
    },

    async setInitialClub() {
      const cityIndex = this.initialCity
      const city = this.getСityList?.[cityIndex] || this.getСityList?.[0]

      if (!city) {
        return
      }

      await this.fetchClubs({ cityId: city.id, filter: 'kidsClub' })

      const clubIndex = this.initialClub
      const club = this.getClubs?.[clubIndex] || this.getClubs?.[0]

      if (club) {
        this.selectedClub = club
      }
    },

    async onCitySelect(idx) {
      const currentCity = this.getСityList[idx]
      if (!currentCity) return
      if (this.$route.params.city === currentCity.slug) return
      try {
        const clubs = await this.fetchClubs({ cityId: currentCity.id, filter: 'kidsClub' })
        if (clubs && clubs.length > 0) {
          const clubSlug = clubs[0].slug
          const kidsClubPage = this.getKidsClubPage(clubSlug)
          this.$router.push(`/fitness/${currentCity.slug}/${clubSlug}/${kidsClubPage}`)
        }
      } catch (err) {
        console.error(err)
      }
    },

    onClubSelect(idx) {
      const currentClub = this.getClubs[idx]
      if (this.$route.params.id === currentClub?.slug) return
      if (!this.$route.params.id && idx === 0) return
      if (currentClub) {
        const kidsClubPage = this.getKidsClubPage(currentClub.slug)

        this.$router.push(`/fitness/${this.$route.params.city}/${currentClub.slug}/${kidsClubPage}`)
      }
    },
  },
}
</script>
